import * as dc from "@/components/layout/list/defaultType";
import { ClipboardProp, DataListParams, DataListProp, DataParams, LayoutProps } from "../../layoutType";
import { defaultFloatFomatter, getInputValueCheck, getMatchingData, runFormFunction, setFormClass } from "../../input/inputFunction";
import dayjs from "dayjs";
import { Debug } from "@/util/debug";
import { DataCols, DataColumnField, DataColumnRecord } from "../../input/inputType";
import { getTranslate } from "@/util/arrayutil";
import { exportElementAsPNGDefault } from "@/util/fileutil";
import {
  cupnoteListCommon,
  qcCommonCols,
  qcCommonInit,
  qcFlavorwheelChart,
  qcFlavorwheelList,
  qcFlavorwheelReverse,
  qcFlavorwheelRotate,
  qcFlavorwheelSet,
  qcFlavorwheelSimple,
  qcRadar,
} from "../../inputCols/qcCols";
import { beaninfoGreenbeanCol, beaninfoGreenbeanList, beaninfoLossCols, beaninfoNameCols } from "../../inputCols/beaninfoCols";
import { brewingChangeCalc, brewingCommon, brewingDefault, brewingInit, brewingSteps, brewingType } from "../../inputCols/brewingCols";
import { roastingProfileCols } from "../../inputCols/roastingCols";
import { isSafari } from "react-device-detect";
import { roastingProfileClipboard } from "../../inputCols/clipboard";
import { Capacitor } from "@capacitor/core";
import { AppDownloadBlank, appRouterPush, fileSaved, fileSaveError } from "@/util/apputil";
import { enLocale } from "@/i18n/routing";
export const InfoIntro = (props: DataListProp): DataListParams | undefined => {
  const t = props.t;
  const ta = props.ta;
  const result = props.result;
  const params = props.params;
  const form = props.form;
  const formMemo = props.formMemo;
  const setValueList = props.setValueList;
  const formFunction = props.formFunction;
  const dataFunction = props.dataFunction;
  const alertContext = props.alertContext;
  const message = props.message;
  const router = props.router;
  // const { message } = App.useApp();

  const saveAlert = fileSaved(alertContext, ta);
  const saveErrorAlert = fileSaveError(alertContext, ta);

  const utcOffset = dayjs().utcOffset() * 60000;

  const brewing_record_test_buttons: DataColumnField = {
    label: "blank",
    itemClassName: "DownloadHidden mb-4",
    fieldId: {
      brewing_record_samples: {
        inputType: "element",
        elementProp: {
          element: "sample_value_input",
          elementType: "button",
          transition: true,
          buttonProp: {
            onClick: () => {
              const temp_data = getMatchingData(form?.current, formMemo?.current, dc.tempBrewingData);
              Debug(temp_data);
              form?.current?.setFieldsValue(temp_data);
              brewingInit(form?.current, formFunction?.current, dataFunction?.current, temp_data, params?.setTimer);
              // brewingChangeCalc(form?.current);
            },
          },
        },
        saveData: false,
      },
      brewing_record_clear: {
        inputType: "element",
        inputClassName: "input_ml",
        elementProp: {
          element: "clear_label",
          elementType: "button",

          transition: true,
          buttonProp: {
            className: "input_ml",
            onClick: () => {
              const temp_data: Record<string, any> = { brewing_step_use: false };
              dc.tempBrewingClearDataFields.forEach((key) => (temp_data[key] = undefined));
              form?.current?.setFieldsValue(temp_data);
              brewingInit(form?.current, formFunction?.current, dataFunction?.current, temp_data, params?.setTimer);
            },
          },
        },
        saveData: false,
      },
    },
  };

  switch (params?.page.page ?? "") {
    case "SiteIntro":
      return {
        ...result,
        dataName: "Intro",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        saveButton: false,
        cancelButton: false,
        clipboard: {
          category: "QCCommon",
          exField: ["roaster_seq", "cupnote_seq", "intro_desc"],
          front: false,
          load: (data) => {
            [
              "cupnote_balance_point",
              "cupnote_aroma_point",
              "cupnote_sweetness_point",
              "cupnote_body_point",
              "cupnote_flavor_point",
              "cupnote_acidity_point",
            ].forEach((item) => runFormFunction(formFunction?.current, item, "inputSync"));
            runFormFunction(formFunction?.current, "cupnote_radar", "changeData");
          },
        },
        timer: dc.brewingTimer,
        dataInit: (data: any) => {
          Debug("Intro init", data);
          if (params?.setTimer) {
            params.setTimer({ timer: dc.brewingTimer, start: undefined });
          }
          setTimeout(() => {
            setFormClass(dataFunction?.current, {
              hidden_step_detail: !(data["brewing_step_use"] === 1),
            });
            brewingChangeCalc(form?.current, dataFunction?.current);
            const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
            if (objs && objs.length > 0) {
              runFormFunction(formFunction?.current, "cupnote_flavor_wheel", "changeData");
              const rotate =
                getInputValueCheck(form?.current, formMemo?.current, dataFunction?.current, data, "cupnote_flavor_wheel_rotate") ?? 0;
              Debug("qcCommonInit", rotate);
              const objs = document.querySelectorAll("form.ant-form .rt-Flex.data-chart.FlavorWheel svg > g > g");
              objs.forEach((g) => {
                const obj = g as SVGGElement;
                const ctm = getTranslate(obj);
                if (ctm) {
                  obj.setAttribute("transform", `translate(${ctm.x}, ${ctm.y}) rotate(${rotate})`);
                }
              });
            }
          }, dc.setTimeoutDelay);
        },
        dataCols: {
          // intro_desc_title: {
          //   label: "intro_desc",
          //   labelClassName: dc.strongLabelClassName + " DownloadInvisible",
          //   valueClassName: "hidden",
          //   fixedValue: "intro_desc",
          // },

          intro_desc: {
            inputType: "display",
            // ...dc.labelHidden,
            // itemClassName: "mb-4",
            label: "blank",
            labelUse: false,
            labelClassName: dc.strongLabelClassName + " DownloadInvisible",
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            readOnly: true,
            noItem: false,
            valueStyle: {
              resize: "none",
              fontSize: "1.2rem",
              fontWeight: "bold",
              flexFlow: "column",
              gridColumn: "1 / span 2",
            },
            textAreaProp: {
              rows: props.isMobile ? (params?.locale === enLocale ? 9 : 7) : 4,
              style: { resize: "none", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center", height: "auto" },
            },
          },
          // site_qrcode: {
          //   ...dc.qrcode,
          //   label: "blank",
          //   edit: { display: true },
          //   fixedValue: `https://coffeein.site/`,
          //   linkOption: { useHost: false },
          // },
          div_1: dc.itemDiv,
          ...qcFlavorwheelReverse(formFunction?.current),
          ...qcFlavorwheelSet(formFunction?.current, alertContext, ta),
          cupnote_flavor_list: {
            ...qcFlavorwheelList(formFunction?.current),
          },
          cupnote_aftertaste_list: { ...cupnoteListCommon, codeGroup: "CNAFTST" },
          cupnote_texture_list: { ...cupnoteListCommon, codeGroup: "CNTXTR" },
          cupnote_feeling_list: { ...cupnoteListCommon, codeGroup: "CNFLNG" },
          div_2: dc.itemDiv,
          brewing_record_test_buttons,
          brewing_grinder_setting: {
            labelClassName: dc.strongLabelClassName,
            itemClassName: "brewing_result",
            fieldId: {
              brewing_bean_mass: { ...dc.mass, variant: "outlined", tooltip: "bean_mass", placeholder: "bean_mass" },
              brewing_grinder_point: {
                ...dc.number2f,
                variant: "outlined",
                tooltip: "grinder_point",
                placeholder: "grinder_point",
                formatter: defaultFloatFomatter,
                inputClassName: dc.inputNumberClassName,
              },
            },
          },
          ...brewingSteps(t, form, formMemo?.current, formFunction?.current, dataFunction?.current, params?.setTimer, false, false),
          div_3: dc.itemDiv,
          cupnote_name_locale: {
            ...dc.inputFull,
            display: params?.locale === enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          cupnote_name: {
            ...dc.inputFull,
            display: params?.locale !== enLocale ? false : undefined,
            noItem: false,
            saveData: false,
            onChange: () => {
              runFormFunction(formFunction?.current, "cupnote_radar", "changeLabel");
            },
          },
          ...qcRadar(formFunction?.current, [params?.locale === enLocale ? "cupnote_name" : "cupnote_name_locale"], "Coffee"),
        },
        tempValue: {
          intro_desc: (
            <>
              {/* HERO */}
              <section className="min-h-[20rem] flex flex-col justify-center items-center text-center px-6">
                <h1 className="text-4xl font-bold mb-6">
                  {t("intro.hero.title")
                    .split("\n")
                    .map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                </h1>

                <p className="text-lg md:text-xl text-gray-600 max-w-2xl mb-8">
                  {t("intro.hero.desc")
                    .split("\n")
                    .map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                </p>
              </section>

              {/* FLOW */}
              <section className="py-20 px-6 bg-gray-50">
                <div className="max-w-5xl mx-auto text-center">
                  <h2 className="text-3xl font-bold mb-12">{t("intro.flow.title")}</h2>

                  <div className="grid grid-cols-2 md:grid-cols-5 gap-6">
                    {t.raw("intro.flow.items").map((label: string, idx: number) => {
                      const icons = ["🌱", "🔥", "📦", "☕", "📝"];
                      return (
                        <div key={label} className="flex flex-col items-center gap-1 text-sm">
                          <span className="text-2xl">{icons[idx]}</span>
                          <span>{label}</span>
                        </div>
                      );
                    })}
                  </div>

                  <p className="mt-8 text-gray-600 text-lg font-medium">{t("intro.flow.desc")}</p>
                </div>
              </section>

              {/* FEATURES */}
              <section className="py-20 px-6">
                <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-10">
                  {["brew", "bean", "roast", "share"].map((key) => (
                    <div key={key}>
                      <h3 className="text-xl font-bold mb-2">{t(`intro.features.${key}.title`)}</h3>
                      <p className="text-gray-600">
                        {t(`intro.features.${key}.desc`)
                          .split("\n")
                          .map((line, i) => (
                            <span key={i}>
                              {line}
                              <br />
                            </span>
                          ))}
                      </p>
                    </div>
                  ))}
                </div>
              </section>

              {/* DIFFERENCE */}
              <section className="py-20 px-6 bg-gray-100 text-center">
                <h2 className="text-3xl font-bold mb-4">{t("intro.difference.title")}</h2>

                <p className="text-gray-600 max-w-xl mx-auto">
                  {t("intro.difference.desc")
                    .split("\n")
                    .map((line, i) => (
                      <span key={i}>
                        {line}
                        <br />
                      </span>
                    ))}
                </p>
              </section>

              {/* CTA */}
              <section className="py-10 text-center">
                {params?.user ? null : (
                  <>
                    <h2 className="text-3xl font-bold mb-6">{t("intro.cta.title")}</h2>

                    <button
                      className="bg-black text-white px-8 py-4 rounded-2xl hover:opacity-90 transition"
                      onClick={() => {
                        appRouterPush(router, "/user/signin");
                      }}
                    >
                      {t("intro.cta.button")}
                    </button>
                  </>
                )}

                <p className="mt-6 text-gray-500">{t("intro.cta.sub")}</p>
              </section>
            </>
          ),
          cupnote_name_locale: "원두이름을 넣으세요.",
          cupnote_name: "Coffee Bean",
          site_qrcode: `https://coffeein.site`,
          ...dc.tempBrewingData,
        },
        hiddenAds: true,
      };
    case "UserIntro":
      return {
        ...result,
        dataName: "Intro",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        dataButtons: false,
        useGuide: false,
        dataCols: {
          user_intro_desc: {
            // ...dc.textArea,
            inputType: "display",
            // ...dc.labelHidden,
            // itemClassName: "mb-4",
            // label: "blank",
            labelClassName: dc.strongLabelClassName,
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            readOnly: true,
            noItem: false,
            valueStyle: { resize: "none", fontSize: "1.2rem", fontWeight: "bold" },
            textAreaProp: {
              rows: props.isMobile ? (params?.locale === enLocale ? 9 : 7) : 4,
              style: { resize: "none", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center", height: "auto" },
            },
          },
          // site_qrcode: {
          //   ...dc.qrcode,
          //   label: "blank",
          //   edit: { display: true },
          //   fixedValue: `https://coffeein.site/`,
          //   linkOption: { useHost: false },
          // },
          div_1: dc.itemDiv,
          user_intro_usernote: {
            ...dc.introTitle,
            fixedValue: "note_write_label",
          },
          user_intro_coffeenote: {
            ...dc.introDefault,
            // label: "bean",
            label: dc.labelLinkButton(router, "/user/usernote/coffeenote", "bean"),
            fixedValue: "user_intro_coffeenote_desc",
          },
          // user_intro_coffeenote_link: {
          //   ...dc.introLink,
          //   fixedValue: "/user/usernote/coffeenote",
          // },
          user_intro_brewingdefault: {
            ...dc.introDefault,
            // label: "brewing_info",
            label: dc.labelLinkButton(router, "/user/usernote/brewingdefault", "brewing_info"),
            fixedValue: "user_intro_brewingdefault_desc",
          },
          // user_intro_brewingdefault_link: {
          //   ...dc.introLink,
          //   fixedValue: "/user/usernote/brewingdefault",
          // },
          user_intro_equip: {
            ...dc.introDefault,
            // label: "user_intro_equip",
            label: dc.labelLinkButton(router, "/user/usernote/equip", "user_intro_equip"),
            fixedValue: "user_intro_equip_desc",
          },
          // user_intro_equip_link: {
          //   ...dc.introLink,
          //   fixedValue: "/user/usernote/equip",
          // },
          div_2: dc.itemDiv,
          user_intro_userinfo: {
            ...dc.introTitle,
            fixedValue: "userinfo_label",
          },
          user_intro_basicinfo: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/user/userinfo/basicinfo", "user_intro_basicinfo"),
            fixedValue: "user_intro_basicinfo_desc",
          },
          // user_intro_basicinfo_link: {
          //   ...dc.introLink,
          //   fixedValue: "/user/userinfo/basicinfo",
          // },
        },

        tempValue: {
          user_intro_desc:
            params?.locale === enLocale ? (
              <>
                Manage your coffee records by date and register your own equipment and brewing method.
                <br />
                The information you register will automatically be used in your coffee history, allowing for more systematic management and
                analysis.
                <br />
                To save your records, please log in with your Google or Apple account.
              </>
            ) : (
              <>
                마신 커피의 기록을 날짜별로 관리하고, 나만의 장비와 추출 방식을 등록해 보세요.
                <br />
                등록한 정보는 내 커피 기록에 자동으로 활용되어, 보다 체계적인 관리와 분석이 가능합니다.
                <br />
                기록을 저장하려면 Google 또는 Apple 계정으로 로그인해주세요.
              </>
            ),
          example: params?.locale === enLocale ? <></> : <></>,
        },
        hiddenAds: true,
      };

    case "CafeIntro":
      return {
        ...result,
        dataName: "CafeIntro",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        dataButtons: false,
        useGuide: false,
        dataCols: {
          cafe_intro_desc: {
            // ...dc.textArea,
            inputType: "display",
            // ...dc.labelHidden,
            // itemClassName: "mb-4",
            // label: "blank",
            labelClassName: dc.strongLabelClassName,
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            readOnly: true,
            noItem: false,
            valueStyle: { resize: "none", fontSize: "1.2rem", fontWeight: "bold" },
            textAreaProp: {
              rows: props.isMobile ? (params?.locale === enLocale ? 9 : 7) : 4,
              style: { resize: "none", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center", height: "auto" },
            },
          },
          div_1: dc.itemDiv,
          cafe_intro_brewing: {
            ...dc.introTitle,
            fixedValue: "brewing_label",
          },
          cafe_intro_brewing_today: {
            ...dc.introDefault,
            // label: "bean",
            label: dc.labelLinkButton(router, "/cafe/brewing/today", "brewing_today_label"),
            fixedValue: "cafe_intro_brewing_today_desc",
          },
          cafe_intro_brewing_result: {
            ...dc.introDefault,
            // label: "bean",
            label: dc.labelLinkButton(router, "/cafe/brewing/result", "brewing_result_label"),
            fixedValue: "cafe_intro_brewing_result_desc",
          },
          cafe_intro_brewing_default: {
            ...dc.introDefault,
            // label: "brewing_info",
            label: dc.labelLinkButton(router, "/cafe/brewing/default", "brewing_default_label"),
            fixedValue: "cafe_intro_brewing_default_desc",
          },
          div_2: dc.itemDiv,
          cafe_intro_qc: {
            ...dc.introTitle,
            fixedValue: "qc_label",
          },
          cafe_intro_qc_coffeebean: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/cupnote/coffeebean", "coffeebeannote_label"),
            fixedValue: "cafe_intro_qc_coffeebean_desc",
          },
          div_3: dc.itemDiv,
          cafe_intro_coffeebean: {
            ...dc.introTitle,
            fixedValue: "coffeebean_label",
          },
          cafe_intro_coffeebean_received: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/coffeebean/received", "coffeebean_received_label"),
            fixedValue: "cafe_intro_coffeebean_received_desc",
          },
          cafe_intro_coffeebean_default: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/coffeebean/default", "coffeebean_default_label"),
            fixedValue: "cafe_intro_coffeebean_default_desc",
          },
          div_4: dc.itemDiv,
          cafe_intro_supplier: {
            ...dc.introTitle,
            fixedValue: "supplier_label",
          },
          cafe_intro_supplier_roaster: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/supplier/roaster", "supplier_roaster_label"),
            fixedValue: "cafe_intro_supplier_roaster_desc",
          },
          div_5: dc.itemDiv,
          cafe_intro_etc: {
            ...dc.introTitle,
            fixedValue: "etc_label",
          },
          cafe_intro_etc_user: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/etc/user", "user_label"),
            fixedValue: "cafe_intro_etc_user_desc",
          },
          cafe_intro_etc_equip: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/etc/equip", "equip_label"),
            fixedValue: "cafe_intro_etc_equip_desc",
          },
          cafe_intro_etc_event: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/etc/event", "event_label"),
            fixedValue: "cafe_intro_etc_event_desc",
          },
          cafe_intro_etc_signup: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/etc/signup", "etc_signup_label"),
            fixedValue: "cafe_intro_etc_signup_desc",
          },
          cafe_intro_etc_etcuser: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/etc/etcuser", "etcuser_label"),
            fixedValue: "cafe_intro_etc_etcuser_desc",
          },
          div_6: dc.itemDiv,
          cafe_intro_userinfo: {
            ...dc.introTitle,
            fixedValue: "userinfo_label",
          },
          cafe_intro_userinfo_basicinfo: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/userinfo/basicinfo", "user_intro_basicinfo"),
            fixedValue: "cafe_intro_userinfo_basicinfo_desc",
          },

          div_end: dc.itemDiv,

          cafe_intro_guide_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          cafe_intro_guide_title: {
            ...dc.introTitle,
            fixedValue: "cafe_intro_guide_title",
          },
          div_guide_title: dc.itemDiv,

          cafe_intro_guide_coffeebean_regist: {
            ...dc.introTitle,
            fixedValue: "coffeebean_regist_label",
          },
          cafe_intro_guide_coffeebean_regist_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "coffeebean_regist_step1_label"),
            fixedValue: "cafe_intro_guide_coffeebean_regist_step1_desc",
          },
          cafe_intro_guide_coffeebean_regist_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "coffeebean_regist_step2_label"),
            fixedValue: "cafe_intro_guide_coffeebean_regist_step2_desc",
          },
          cafe_intro_guide_coffeebean_regist_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "coffeebean_regist_step3_label"),
            fixedValue: "cafe_intro_guide_coffeebean_regist_step3_desc",
          },
          div_coffeebean_regist: dc.itemDiv,

          cafe_intro_guide_brewing_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          cafe_intro_guide_brewing: {
            ...dc.introTitle,
            fixedValue: "brewing_label",
          },
          cafe_intro_guide_brewing_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "brewing_step1_label"),
            fixedValue: "cafe_intro_guide_brewing_step1_desc",
          },
          cafe_intro_guide_brewing_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "brewing_step2_label"),
            fixedValue: "cafe_intro_guide_brewing_step2_desc",
          },
          cafe_intro_guide_brewing_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "", "brewing_step3_label"),
            fixedValue: "cafe_intro_guide_brewing_step3_desc",
          },
          div_guide_brewing: dc.itemDiv,
        },
        tempValue: {
          cafe_intro_desc:
            params?.locale === enLocale ? (
              <>
                You can record various information about the coffee you drink by date.
                <br />
                You can also register your own equipment and brewing method.
                <br />
                This registered information can be used to record your coffee by date.
                <br />
                You will need to sign in with your Google or Apple ID to save this information.
              </>
            ) : (
              <>
                카페에서 추출한 내용을 기록하고 분석합니다.
                <br />
                쉬운 기록을 위해 카페의 장비와 추출 방식을 등록 할 수 있습니다.
                <br />
                이렇게 일자별로 등록된 자료를 활용해 다음 세팅을 잡는데 활용하세요.
                <br />
                또한 카페에서 사용되는 원두를 등록하고 원두의 컵노트, 추출 방식을 기록해 다른 사람과 공유할 수 있습니다.
              </>
            ),
          example: params?.locale === enLocale ? <></> : <></>,
        },
        hiddenAds: true,
      };
    case "RoasterIntro":
      return {
        ...result,
        dataName: "RoasterIntro",
        dataFetch: {},
        useList: false,
        useDefaultId: true,
        defaultMode: "write",
        dataButtons: false,
        useGuide: false,

        dataCols: {
          roaster_intro_desc: {
            // ...dc.textArea,
            inputType: "display",
            // ...dc.labelHidden,
            // itemClassName: "mb-4",
            // label: "blank",
            labelClassName: dc.strongLabelClassName,
            saveData: false,
            variant: "borderless",
            edit: { showCount: false },
            readOnly: true,
            noItem: false,
            valueStyle: { resize: "none", fontSize: "1.2rem", fontWeight: "bold" },
            textAreaProp: {
              rows: props.isMobile ? (params?.locale === enLocale ? 9 : 7) : 4,
              style: { resize: "none", fontSize: "1.2rem", fontWeight: "bold", textAlign: "center", height: "auto" },
            },
          },
          div_roasting: dc.itemDiv,
          roaster_intro_roasting: {
            ...dc.introTitle,
            fixedValue: "roasting_label",
          },
          roaster_intro_roasting_result: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/roasting/result", "roasting_result_label"),
            fixedValue: "roaster_intro_roasting_result_desc",
          },
          roaster_intro_roasting_default: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/roasting/default", "roasting_default_label"),
            fixedValue: "roaster_intro_roasting_default_desc",
          },
          div_blending: dc.itemDiv,
          roaster_intro_blending: {
            ...dc.introTitle,
            fixedValue: "blending_label",
          },
          roaster_intro_blending_result: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/blending/result", "blending_result_label"),
            fixedValue: "roaster_intro_blending_result_desc",
          },
          roaster_intro_blending_default: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/blending/default", "blending_default_label"),
            fixedValue: "roaster_intro_blending_default_desc",
          },

          div_qc: dc.itemDiv,
          roaster_intro_qc: {
            ...dc.introTitle,
            fixedValue: "qc_label",
          },
          roaster_intro_qc_blendingresult: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/blr", "brewing_label"),
            fixedValue: "roaster_intro_qc_blendingresult_desc",
          },
          roaster_intro_qc_brewingdefault: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/blr", "qc_brewingdefault_label"),
            fixedValue: "roaster_intro_qc_brewingdefault_desc",
          },
          roaster_intro_qc_blending: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/blending", "qc_blending_label"),
            fixedValue: "roaster_intro_qc_blending_desc",
          },
          roaster_intro_qc_roasting: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/roasting", "qc_roasting_label"),
            fixedValue: "roaster_intro_qc_roasting_desc",
          },
          roaster_intro_qc_greenbean: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/greenbean", "qc_greenbean_label"),
            fixedValue: "roaster_intro_qc_greenbean_desc",
          },

          div_greenbean: dc.itemDiv,
          roaster_intro_greenbean: {
            ...dc.introTitle,
            fixedValue: "greenbean_label",
          },
          roaster_intro_greenebean_list: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/greenebean/list", "greenbean_list_label"),
            fixedValue: "roaster_intro_greenebean_list_desc",
          },
          roaster_intro_greenebean_default: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/greenebean/default", "greenbean_default_label"),
            fixedValue: "roaster_intro_greenebean_default_desc",
          },

          div_customer: dc.itemDiv,
          roaster_intro_customer: {
            ...dc.introTitle,
            fixedValue: "customer_label",
          },
          roaster_intro_customer_cafe: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/cafe", "customer_cafe_label"),
            fixedValue: "roaster_intro_customer_cafe_desc",
          },
          roaster_intro_customer_registercafe: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/registercafe", "customer_registercafe_label"),
            fixedValue: "roaster_intro_customer_registercafe_desc",
          },
          roaster_intro_customer_etccafe: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/etccafe", "customer_etccafe_label"),
            fixedValue: "roaster_intro_customer_etccafe_desc",
          },

          div_etc: dc.itemDiv,
          roaster_intro_etc: {
            ...dc.introTitle,
            fixedValue: "etc_label",
          },
          roaster_intro_etc_user: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/user", "user_label"),
            fixedValue: "roaster_intro_etc_user_desc",
          },
          roaster_intro_etc_equip: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/equip", "equip_label"),
            fixedValue: "roaster_intro_etc_equip_desc",
          },
          roaster_intro_etc_event: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/event", "event_label"),
            fixedValue: "roaster_intro_etc_event_desc",
          },
          roaster_intro_etc_signup: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/event", "etc_signup_label"),
            fixedValue: "roaster_intro_etc_signup_desc",
          },
          roaster_intro_etc_etcuser: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/event", "etcuser_label"),
            fixedValue: "roaster_intro_etc_etcuser_desc",
          },

          div_user: dc.itemDiv,
          roaster_intro_userinfo: {
            ...dc.introTitle,
            fixedValue: "userinfo_label",
          },
          roaster_intro_basicinfo: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/userinfo/basicinfo", "user_intro_basicinfo"),
            fixedValue: "roaster_intro_basicinfo_desc",
          },
          // user_intro_basicinfo_link: {
          //   ...dc.introLink,
          //   fixedValue: "/user/userinfo/basicinfo",
          // },
          div_end: dc.itemDiv,

          roaster_intro_guide_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          roaster_intro_guide_title: {
            ...dc.introTitle,
            fixedValue: "roaster_intro_guide_title",
          },
          div_guide_title: dc.itemDiv,

          roaster_intro_guide_blending_regist: {
            ...dc.introTitle,
            fixedValue: "blending_regist_label",
          },
          roaster_intro_guide_blending_regist_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/create", "blending_regist_step1_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step1_desc",
          },
          roaster_intro_guide_blending_regist_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/greenbean/list/write", "blending_regist_step2_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step2_desc",
          },
          roaster_intro_guide_blending_regist_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/equip/write", "blending_regist_step3_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step3_desc",
          },
          equip_type: {
            ...dc.select,
            label: "blank",
            labelClassName: dc.mobileHidden,
            inputClassName: dc.inputCountryClassName,
            required: false,
            minLength: 3,
            maxLength: 45,
            placeholder: "equip_type",
            codeGroup: "EQUIP",
          },

          roaster_intro_guide_blending_regist_step4: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roasting/default/write", "blending_regist_step4_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step4_desc",
          },
          roaster_intro_guide_blending_regist_step5: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/blending/default/write", "blending_regist_step5_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step5_desc",
          },
          roaster_intro_guide_blending_regist_step6: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/blending/write", "blending_regist_step6_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step6_desc",
          },
          roaster_intro_guide_blending_regist_step7: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/roasting/result/write", "blending_regist_step7_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step7_desc",
          },
          roaster_intro_guide_blending_regist_step8: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/blending/result/write", "blending_regist_step8_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step8_desc",
          },
          roaster_intro_guide_blending_regist_step9: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/info/bean/rt/EfDM9-fyCD22gAqaR9Il8Q", "blending_regist_step9_label"),
            fixedValue: "roaster_intro_guide_blending_regist_step9_desc",
          },
          blending_result_uuid_str: {
            ...dc.qrcode,
            dataInputMode: "view",
            edit: { display: true },
            label: "blank",
            labelClassName: dc.mobileHidden,
            fixedValue: "/info/bean/rt/EfDM9-fyCD22gAqaR9Il8Q",
          },

          div_guide_blending_regist: dc.itemDiv,

          roaster_intro_guide_qc_regist_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          roaster_intro_guide_qc_regist: {
            ...dc.introTitle,
            fixedValue: "qc_regist_label",
          },
          roaster_intro_guide_qc_regist_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/equip/write", "qc_regist_step1_label"),
            fixedValue: "roaster_intro_guide_qc_regist_step1_desc",
          },
          roaster_intro_guide_qc_regist_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/brd/write", "qc_regist_step2_label"),
            fixedValue: "roaster_intro_guide_qc_regist_step2_desc",
          },
          roaster_intro_guide_qc_regist_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/qc/blr/write", "qc_regist_step3_label"),
            fixedValue: "roaster_intro_guide_qc_regist_step3_desc",
          },
          div_guide_qc_regist: dc.itemDiv,

          roaster_intro_guide_user_regist_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          roaster_intro_guide_user_regist: {
            ...dc.introTitle,
            fixedValue: "user_regist_label",
          },
          roaster_intro_guide_user_regist_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/event/write", "user_regist_step1_label"),
            fixedValue: "roaster_intro_guide_user_regist_step1_desc",
          },
          roaster_intro_guide_user_regist_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/user/link/roastersignup/", "user_regist_step2_label"),
            fixedValue: "roaster_intro_guide_user_regist_step2_desc",
          },
          roaster_intro_guide_user_regist_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/signup", "user_regist_step3_label"),
            fixedValue: "roaster_intro_guide_user_regist_step3_desc",
          },
          roaster_intro_guide_user_regist_step4: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/user", "user_regist_step4_label"),
            fixedValue: "roaster_intro_guide_user_regist_step4_desc",
          },
          roaster_intro_guide_user_regist_step5: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/etcuser", "user_regist_step5_label"),
            fixedValue: "roaster_intro_guide_user_regist_step5_desc",
          },
          div_guide_user_regist: dc.itemDiv,

          roaster_intro_guide_customer_regist_blank: {
            ...dc.introTitle,
            fixedValue: "blank",
          },
          roaster_intro_guide_customer_regist: {
            ...dc.introTitle,
            fixedValue: "customer_regist_label",
          },
          roaster_intro_guide_customer_regist_step1: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/etc/event/write", "customer_regist_step1_label"),
            fixedValue: "roaster_intro_guide_customer_regist_step1_desc",
          },
          roaster_intro_guide_customer_regist_step2: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/cafe/supplier/roasterregister", "customer_regist_step2_label"),
            fixedValue: "roaster_intro_guide_customer_regist_step2_desc",
          },
          roaster_intro_guide_customer_regist_step3: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/registercafe", "customer_regist_step3_label"),
            fixedValue: "roaster_intro_guide_customer_regist_step3_desc",
          },
          roaster_intro_guide_customer_regist_step4: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/cafe", "customer_regist_step4_label"),
            fixedValue: "roaster_intro_guide_customer_regist_step4_desc",
          },
          roaster_intro_guide_customer_regist_step5: {
            ...dc.introDefault,
            label: dc.labelLinkButton(router, "/roaster/customer/etccafe", "customer_regist_step5_label"),
            fixedValue: "roaster_intro_guide_customer_regist_step5_desc",
          },
          div_guide_customer_regist: dc.itemDiv,
        },
        tempValue: {
          roaster_intro_desc:
            params?.locale === enLocale ? (
              <>
                Record the entire roasting process and complete the result into a finished product.
                <br />
                Create products using roasted beans and systematically manage everything from cup notes and brewing methods to quality.
                <br />
                Easily share your finished products with anyone via links and QR codes.
              </>
            ) : (
              <>
                로스팅의 모든 과정을 기록하고, 그 결과를 하나의 제품으로 완성하세요.
                <br />
                로스팅된 원두로 제품을 만들고, 컵노트와 추출 방식, 그리고 품질까지 체계적으로 관리할 수 있습니다.
                <br />
                완성된 제품을 링크와 QR 코드를 통해 다른 사람과 쉽게 공유해보세요.
              </>
            ),
          example: params?.locale === enLocale ? <></> : <></>,
        },
        hiddenAds: true,
      };
    default:
      return undefined;
  }
};
